import React, { useEffect, useMemo, useState } from "react";




console.log("WbalTable: LOADED no-database version of WtBalTable component");

const STORAGE_KEY = "avicalc_weight_balance_rows";
const FUEL_KEY = "avicalc_weight_balance_fuel";

// order for aircraft Normal-category performance operating stations in the POH or AFM.
// the Utility-category is not referenced here
const defaultRows = [
  { id: "Basic Empty Weight", weight: "", arm: "" },
  { id: "Pilot", weight: "", arm: "" },
  { id: "CoPilot", weight: "", arm: "" },
  { id: "Rear Passenger1", weight: "", arm: "" },
  { id: "Rear Passenger2", weight: "", arm: "" },
  { id: "Baggage", weight: "", arm: "" },
  { id: "Fuel", weight: "", arm: "" },
];

const defaultFuel = {
  totalFuelGallons: "52.0",
  usableFuelGallons: "48.0",
  runupGallons: "2.1",
  fuelArm: "48.43",
  
  maxGrossWeight: "2575",
};



const toNum = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

function WbalTable() {
  const [rows, setRows] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved ? JSON.parse(saved) : defaultRows;
    } catch {
      return defaultRows;
    }
  });
  const [fuel, setFuel] = useState(() => {
    try {
      const saved = localStorage.getItem(FUEL_KEY);
      return saved ? JSON.parse(saved) : defaultFuel;
    } catch {
      return defaultFuel;
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(rows));
  }, [rows]);

  useEffect(() => {
    localStorage.setItem(FUEL_KEY, JSON.stringify(fuel));
  }, [fuel]);

  const updateRow = (index, field, value) => {
    setRows((prev) =>
      prev.map((row, i) =>
        i === index ? { ...row, [field]: value } : row
      )
    );
  };
    const updateFuel = (field, value) => {
    setFuel((prev) => ({
      ...prev,
      [field]: value,
    }));
  };





/** 
 * 
 * helper function to extract a station key for sorting purposes
 * stationKey:anonymous function that takes one parameter 'w'
 * 'w' is a row object that may have properties like 'id', 'station', or 'name'
 * w?.id is for optional chaining. if 'w' is null or undefined, it won't throw an error
 * 
 * ?? nullish coalescing operator. if w?.id is null or undefined, it will check w?.station
 * fallback is empty string if all are null or undefined
 */

const addRow = () => {
    setRows((prev) => [
      ...prev,
      { id: `Station ${prev.length + 1}`, weight: "", arm: "" },
    ]);
  };

  const deleteRow = (index) => {
    setRows((prev) => prev.filter((_, i) => i !== index));
  };

  const resetRows = () => {
    setRows(defaultRows);
    setFuel(defaultFuel);
  };

  const calculations = useMemo(() => {
    let normalWeight = 0;
    let normalMoment = 0;


    rows.forEach((row) => {
      const weight = toNum(row.weight);
      const arm = toNum(row.arm);

      if (weight != null && arm != null) {
        normalWeight += weight;
        normalMoment += weight * arm;
      }
    });
    const totalFuelGal = toNum(fuel.totalFuelGallons);
    const usableFuelGal = toNum(fuel.usableFuelGallons);
    const runupGal = toNum(fuel.runupGallons);
    const lbsPerGal = 6.1;
    const fuelArm = toNum(fuel.fuelArm);
    const maxGross = toNum(fuel.maxGrossWeight);

    // W&B uses TOTAL fuel
    const totalFuelWeight =
    totalFuelGal != null && lbsPerGal != null ? totalFuelGal * lbsPerGal : 0;
    console.log("calculations: totalFuelWeight =", totalFuelWeight);

    const totalFuelMoment =
    fuelArm != null ? totalFuelWeight * fuelArm : 0;

    const runupFuelWeight =
    runupGal != null && lbsPerGal != null ? runupGal * lbsPerGal : 0;

    const runupFuelMoment =
    fuelArm != null ? runupFuelWeight * fuelArm : 0;

    const takeoffFuelWeight = Math.max(0, totalFuelWeight - runupFuelWeight);

    const takeoffFuelMoment =
    fuelArm != null ? takeoffFuelWeight * fuelArm : 0;

    // informational only
    const remainingUsableGallons =
    usableFuelGal != null && runupGal != null
        ? Math.max(0, usableFuelGal - runupGal)
        : 0;

    // totals (fuel already included via Fuel row)
    const takeoffWeight = normalWeight + takeoffFuelWeight;
    const takeoffMoment = normalMoment + takeoffFuelMoment;
    const takeoffCg = takeoffWeight > 0 ? takeoffMoment / takeoffWeight : null;



    const overGross =
      maxGross != null && takeoffWeight > maxGross;



    return {
      normalWeight,
      normalMoment,
      remainingUsableGallons,
      runupFuelWeight,
      runupFuelMoment,
      totalFuelWeight,
      totalFuelMoment,
      takeoffFuelWeight,
      takeoffFuelMoment,
      takeoffWeight,
      takeoffMoment,
      takeoffCg,
      maxGross,
      overGross,
      fuelArm,
      totalWeight: takeoffWeight,
      totalMoment: takeoffMoment,
      cg: takeoffCg,
    };
  }, [rows, fuel]);

 

  return (
    <>
      <h2 className="caption_text">Weight and Balance</h2>

      <table id="wtbals">
        
        <caption className="caption_text">
            Fuel Setup (Fuel Weight = 6.1 lbs/gal)
            </caption>
        <thead>
          <tr>
            <th>Total Fuel Gals.</th>
            <th>Usable Fuel Gals.</th>
            <th>Runup Fuel Gals.</th>
            
            <th>Fuel Arm</th>
            <th>Max Gross Weight</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>
                <input
                className="navlog-input"
                type="number"
                value={fuel.totalFuelGallons}
                onChange={(e) => updateFuel("totalFuelGallons", e.target.value)}
                />
            </td>

            <td>
                <input
                className="navlog-input"
                type="number"
                value={fuel.usableFuelGallons}
                onChange={(e) => updateFuel("usableFuelGallons", e.target.value)}
                />
            </td>

            <td>
              <input
                className="navlog-input"
                type="number"
                value={fuel.runupGallons}
                onChange={(e) => updateFuel("runupGallons", e.target.value)}
              />
            </td>

            

            <td>
              <input
                className="navlog-input"
                type="number"
                value={fuel.fuelArm}
                onChange={(e) => updateFuel("fuelArm", e.target.value)}
              />
            </td>

            <td>
              <input
                className="navlog-input"
                type="number"
                value={fuel.maxGrossWeight}
                onChange={(e) => updateFuel("maxGrossWeight", e.target.value)}
              />
            </td>
          </tr>
        </tbody>
      </table>

      <table id="wtbals">
        <caption className="caption_text">Weight and Balance Table</caption>

        <thead>
          <tr>
            <th className="station_box">Station</th>
            <th className="weight_box">Weight lbs.</th>
            <th className="arm_box">Arm In.</th>
            <th className="moment_box">Moment lb-In.</th>
            <th className="delete_box">Delete</th>
          </tr>
        </thead>

        <tbody>
          {rows.map((row, index) => {
            const isFuelRow =
              String(row.id || "").trim().toLowerCase() === "fuel";
                console.log("row.id =", row.id, "isFuelRow =", isFuelRow);

            const weight = toNum(row.weight);
            const arm = toNum(row.arm);
            const moment =
              weight != null && arm != null ? weight * arm : null;

            return (
              <tr key={`${row.id}-${index}`}>
                <td>
                    {isFuelRow ? (
                        <strong>Total Fuel</strong>
                    ) : (
                  <input
                    className="navlog-input"
                    value={row.id}
                    onChange={(e) => updateRow(index, "id", e.target.value)}
                  />
                    )}
                </td>

                <td>
                    {isFuelRow ? (
                        <strong>
                        {calculations.totalFuelWeight.toFixed(1)} lbs.
                        </strong>
                    ) : (
                  <input
                    className="navlog-input"
                    type="number"
                    value={row.weight}
                    onChange={(e) =>
                      updateRow(index, "weight", e.target.value)
                    }
                  />
                  )}
                </td>

                <td>
                    {isFuelRow ? (
                        <strong>
                        {calculations.fuelArm != null
                            ? calculations.fuelArm.toFixed(2)
                            : ""}
                        </strong>
                    ) : (
                  <input
                    className="navlog-input"
                    type="number"
                    value={row.arm}
                    onChange={(e) =>
                      updateRow(index, "arm", e.target.value)
                    }
                  />
                    )}
                </td>

                <td>
                    {isFuelRow
                        ? calculations.totalFuelMoment.toFixed(1)
                        : moment != null
                        ? moment.toFixed(1)
                        : ""}
                    </td>

                <td>
                    {!isFuelRow && (
                        <button type="button" onClick={() => deleteRow(index)}>
                        Delete
                        </button>
                    )}
                </td>
              </tr>
            );
          })}

          <tr>
            
            
          </tr>

          <tr>
            <td>
              <strong>Runup Fuel</strong>
            </td>
            <td>
              <strong>-{calculations.runupFuelWeight.toFixed(1)} lbs.</strong>
            </td>

            <td>
              <strong>
                {calculations.fuelArm != null
                    ? calculations.fuelArm.toFixed(2)
                    : ""}
              </strong>
            </td>

            <td>
              <strong>-{calculations.runupFuelMoment.toFixed(1)}</strong>
            </td>
            <td></td>

          </tr>

          <tr>
            <td>
              <strong>
                Takeoff Fuel (Weight & Moment)
                 
              </strong>
            </td>
            <td>
              <strong>
                {calculations.takeoffFuelWeight.toFixed(1)} lbs.
                
                
                </strong>
            </td>
            <td>
                <strong>
                    {calculations.fuelArm != null
                    ? calculations.fuelArm.toFixed(2)
                    : ""}
                </strong>
            </td>
            <td>
              <strong>{calculations.takeoffFuelMoment.toFixed(1)}</strong>
            </td>
            <td></td>
          </tr>

          <tr>
            <td>
              <strong>Takeoff Weight & Moment</strong>
            </td>
            <td>
              <strong>{calculations.totalWeight.toFixed(1)} lbs.</strong>
            </td>
            <td>
              
            </td>
            <td>
              <strong>{calculations.totalMoment.toFixed(1)}</strong>
            </td>
            <td></td>
          </tr>
        <tr>
            <td>
              <strong>Takeoff CG</strong>
            </td>
            <td>
              <strong>
                
                {calculations.cg != null
                  ? calculations.cg.toFixed(2)
                  : ""} Inches
              </strong>
              </td>
              <td colSpan="2">
              <strong>Inches aft of datum</strong>
            </td>
            <td></td>
        </tr>
          <tr>
            <td>
              <strong>Max Allowed Gross Weight</strong>
            </td>
            <td>
              <strong>
                {calculations.maxGross ?? ""} lbs.
                </strong>
            </td>
            <td colSpan="2">
              <strong
              style={{
                    color: calculations.overGross ? "red" : "black",
                    fontWeight: calculations.overGross ? "bold" : "normal",
                    }}   
                    >
                {calculations.overGross
                  ? "Takeoff weight is over max gross weight"
                  : "Takeoff weight is within weight limit"}
              </strong>
            </td>
            <td></td>
            
            
          </tr>
          <tr>
            <td>
              <strong>Takeoff Usable Fuel {""}  
                 </strong>
            </td>
            <td>
             {calculations.remainingUsableGallons.toFixed(2)} gal.
            </td>
            <td colSpan="2">
              
            </td>
            <td></td>
            
            
          </tr>
          
        </tbody>
      </table>

      <div className="wtbal-controls">
        <button type="button" onClick={addRow}>
          + Add Station
        </button>

        <button type="button" onClick={resetRows}>
          Reset
        </button>
      </div>
        <div style={{ marginTop: "28px", fontSize: "20px", fontWeight: "bold", color: "#333" }}>
        <strong>Note:</strong> This tool calculates weight, moment, and CG only.
        CG envelope verification must be performed using the aircraft POH/AFM.
        </div>
      
    </>
  );
}

export default WbalTable;